import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import classNames from "classnames";
import { merge, $, presets, media } from "glamor";
import MenuItemDecorator from "./menu-item-decorator";
import theme from "styles/theme";
import { NewBadge, NewIndicator } from "./new-badge";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                display: "block",
                position: "relative",
                textAlign: "left",
                color: "rgba(255,255,255,.8)",
                transition: "all .15s ease-in-out",
                padding: "0 8px",
                overflow: "hidden",
                lineHeight: "36px",
                height: "36px",
            },
            $(".primary", {
                height: "60px",
                lineHeight: "60px",
                background: theme.palette.darkerGrey,
            }),
            $(":hover", {
                background: "rgba(153,153,153,.12)",
                color: "white",
            }),
            $(".hover", {
                background: "rgba(153,153,153,.12)",
                color: "white",
            }),
            $(":active", {
                color: "rgba(255,255,255,1)",
            }),
            $(".active", {
                color: "rgba(255,255,255,1)",
            }),
            $(".hover.primary", {
                background: theme.palette.darkGrey,
            }),
            $(" > .icon", {
                position: "absolute",
                fill: "rgba(255,255,255,.8) !important",
                top: "50%",
                left: "18px",
                transform: "translate(0, -50%)",
                transition: "all .15s ease-in-out",
            }),
            $(".hover > .icon", {
                fill: "white !important",
            }),
            $(" > .label", {
                fontSize: "14px",
                minWidth: "160px",
                padding: "0px",
                margin: "0px",
            }),
            $(".hasIcon > .label", {
                marginLeft: "52px",
            }),
            $(" .pointer", {
                display: "none",
                width: "0px",
                height: "0px",
                borderTop: "8px solid transparent",
                borderBottom: "8px solid transparent",
                borderRight: "8px solid white",
                position: "absolute",
                top: "50%",
                right: "0",
                transform: "translate(0, -50%)",
            }),
            $(".isSectionChild > .label", {
                marginLeft: "22px",
            }),
            media(
                presets.phablet,
                merge(
                    $(" .pointer", {
                        display: "block",
                    }),
                    $(":active", {
                        color: "rgba(255,255,255,.8)",
                    }),
                    $(".active", {
                        color: "rgba(255,255,255,.8)",
                    }),
                ),
            ),
        );
    }
    return styles;
};

/** @augments {PureComponent<any, any>} */
@MenuItemDecorator
class MenuItem extends PureComponent {
    static propTypes = {
        Icon: PropTypes.func,
        to: PropTypes.string,
        onClick: PropTypes.func,
        label: PropTypes.string.isRequired,
        newTab: PropTypes.bool,
        showLabel: PropTypes.bool,
        style: PropTypes.object,
        primary: PropTypes.bool,
        className: PropTypes.string,
        dataTest: PropTypes.string,
        addNewIndicator: PropTypes.bool,
        addNewBadge: PropTypes.bool,
        badge: PropTypes.any,
    };

    static defaultProps = {
        showLabel: true,
        newTab: false,
        primary: false,
        hasAccess: true,
    };

    render() {
        const { to = "#", Icon, label, newTab, primary, hasAccess, onClick, children, matches } = this.props;
        const { location, className, dataTest, addNewIndicator, addNewBadge, badge } = this.props;

        const { hover } = this.state;

        if (!hasAccess) {
            return null;
        }

        let matchesRoute = false;
        if (matches) {
            (Array.isArray(matches) ? matches : [matches]).some((match) => {
                matchesRoute = match.test(location.pathname);
                return matchesRoute;
            });
        }

        return (
            <a
                {...getStyles()}
                className={classNames(
                    {
                        hover,
                        hasSubmenu: !!children,
                        hasIcon: !!Icon,
                        active: matchesRoute,
                        primary,
                    },
                    className,
                )}
                href={to}
                target={newTab ? "_blank" : undefined}
                onClick={onClick}
                data-test={dataTest}
            >
                {Icon && <Icon className="icon" />}
                {Icon && addNewIndicator && <NewIndicator />}
                <span className="label">
                    {addNewBadge ? <NewBadge label={label} badge={badge} /> : <span>{label}</span>}
                </span>
                {Icon && matchesRoute && <div className="pointer" />}
            </a>
        );
    }
}

export default MenuItem;
